"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithViewGroup = exports.prepareSvgStr = exports.fixSvgExportResult = exports.fixSvgData = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var wrapWithViewGroup = exports.wrapWithViewGroup = function wrapWithViewGroup(xmlDoc) {
  var svgElement = xmlDoc.firstElementChild;
  var firstGroup = Array.from(svgElement.children).find(function (child) {
    return child.tagName === 'g';
  });
  if (firstGroup.id === 'designerLayer') {
    var elements = _toConsumableArray(svgElement.children);
    var viewGroup = xmlDoc.createElementNS(svgElement.namespaceURI, 'g');
    viewGroup.id = 'viewGroup';
    elements.forEach(function (element) {
      viewGroup.appendChild(element);
    });
    svgElement.appendChild(viewGroup);
  } else {
    firstGroup.id = 'viewGroup';
  }
};
var prepareSvgStr = exports.prepareSvgStr = function prepareSvgStr(svgStr) {
  return svgStr.replace(/&nbsp;/g, '&#160;') // replace nbsp with unicode char number (Safari DOMParser issue)
  .replace(/(<image [^>]*xlink:href=")https?:\/\/[^/]+/g, '$1') // make image paths relative
  .replace(/\s?translate\(0,0\)\s?/, '');
}; // remove extra translate to origin

var fixSvgExportResult = exports.fixSvgExportResult = function fixSvgExportResult(svgStr) {
  return svgStr.replace(/path xmlns="\S*"/g, 'path').replace(/xlink:href="([^"]+)"/g, function (match, p1) {
    return "xlink:href=\"".concat(p1.split('?')[0], "\"");
  }).replace(/viewBox="([^"]+),([^"]+),([^"]+),([^"]+)"/g, "viewBox=\"$1 $2 $3 $4\"");
};
var fixSvgData = exports.fixSvgData = function fixSvgData(svgStr) {
  // remove metadata
  svgStr = svgStr.replace(/<metadata>[\s\S]+<\/metadata>/, '');
  // add width and height to svg element if not present
  if (!/<svg[^>]+(width|height)=[^>]+>/.test(svgStr)) {
    svgStr = svgStr.replace(/(<svg[^>]+viewBox="([^"]+)\s([^"]+)\s([^"]+)\s([^"]+)")/, '$1 width="$4" height="$5"');
  }
  return svgStr;
};